import classNames from "classnames/bind";
import styles from "./HeaderSubmenu.module.scss";

import SmartLink from "common/wrapper/SmartLink";
import type { ResolvedSubNavItems } from "resolvers/base/subNavigationResolver";
import { memo, useRef } from "react";
import { Timeout } from "react-number-format/types/types";

const cx = classNames.bind(styles);

export type SubmenuProps = {
    navItems: ResolvedSubNavItems[];
    activeSubMenuId: string | null;
    activeMegaMenuId: string | null;
    handleToggleMegaMenu: (key: string | null) => void;
    prefetch?: boolean;
};

const HeaderSubmenu: React.FC<SubmenuProps> = ({
    navItems,
    activeSubMenuId,
    handleToggleMegaMenu,
    activeMegaMenuId,
    prefetch = false,
}: SubmenuProps) => {
    const timeout = useRef<Timeout | null>(null);

    const handleOnMouseEnter = (condition: boolean, megaMenuId?: string) => {
        //await 0.2 seconds before the opening of the menu to avoid having unintended menus open when user mouses over
        timeout.current = setTimeout(() => {
            condition && handleToggleMegaMenu(megaMenuId ?? null);
        }, 200); // same wait as legacy
    };

    const handleOnMouseLeave = () => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = null;
        }
    };

    return (
        <div className={cx("subMenu")}>
            <div className={cx("widthConstrain")}>
                {!!navItems.length &&
                    activeSubMenuId &&
                    navItems.map(({ id, items }) => {
                        return (
                            <ul key={id} className={cx("list", { hide: activeSubMenuId !== id })}>
                                {items.map(({ text, link, megaMenuId }, index) => {
                                    const isLinkAndNotMegaMenu = link && !megaMenuId;

                                    return (
                                        <li
                                            key={`${id}-${index}`}
                                            onMouseEnter={() =>
                                                handleOnMouseEnter(!!megaMenuId, megaMenuId)
                                            }
                                            onMouseLeave={() => handleOnMouseLeave()}
                                            className={cx("item", {
                                                active: megaMenuId === activeMegaMenuId,
                                                stockNumber: megaMenuId === "stock_number_search",
                                            })}
                                        >
                                            {isLinkAndNotMegaMenu ? (
                                                <SmartLink href={link} prefetch={!!prefetch}>
                                                    <a className={cx("link")}>{text}</a>
                                                </SmartLink>
                                            ) : (
                                                <span className={cx("link")}>{text}</span>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        );
                    })}
            </div>
        </div>
    );
};

export default memo(HeaderSubmenu);
